// extracted by css-extract-rspack-plugin
export default {"root":"root-GcXvLW","withFooter":"withFooter-mx600q","scroll":"scroll-f2BT0A","table":"table-f9O5Gk"};